import React from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement, gridConfig, Price as PriceElement } from '@tvg/fuse-design';
import { PriceProps } from './PriceProps';

const Container = styled.div`
  margin-bottom: var(--spacing-space16);
  order: 0;

  @media (min-width: ${gridConfig.m.minWidth}) {
    order: 1;
  }
`;

function Price({ price }: { price: PriceProps }): JSX.Element {
  const { currencySymbol, unitPrice } = price;

  const currPrice = price.currentFrom !== undefined ? Number(price.currentFrom.slice(1)) : price.unformattedPrice;
  const prevPrice = price.previousFrom !== undefined ? price.wasFromUnformatted : price.unformattedPrevious;
  const showSaving = !!price.unformattedSaving || !!price.unformattedSavingTo;
  const savingPrice = price.unformattedSavingTo || price.unformattedSaving;
  const isEuro = currencySymbol !== '£';

  return (
    <Container>
      <PriceElement
        id="product-price"
        dataTestId="product-price"
        headingTag="h2"
        showCurrentFrom={!!price.currentFrom}
        showPreviousFrom={!!price.previousFrom}
        price={currPrice}
        prevPrice={prevPrice}
        saving={savingPrice}
        showSave={showSaving}
        isEuro={isEuro}
      />
      {unitPrice && (
        <TypographyElement data-testid="unit-price" type="paragraph" size="1">
          {unitPrice}
        </TypographyElement>
      )}
    </Container>
  );
}
export default Price;
